/* =================== CALCULADORA =================== */

/* etapas/processo de calculadora */
if (param1 == 'calculadora') {

  // FORMULARIO EM ETAPA
  $(function () {

    var $sections = $(".form-section");

    /* Navagacao etapas */
    function navigateTo(index) {
      console.log('indice'+index);
      // Mark the current section with the class 'current'
      $sections.removeClass("current").eq(index).addClass("current");
      // Show only the navigation buttons that make sense for the current section:
      $(".btn-container .previous").toggle(index > 0);
      var atTheEnd = index >= $sections.length - 1;
      $(".btn-container .next").toggle(!atTheEnd);
      $(".btn-container [type=submit]").toggle(atTheEnd);
      $(".next").html("Calcular &nbsp<i class='fas fa-arrow-right' style='margin-right: 0px;'></i>");
      $('.calculadora-form-container').css('justify-content', 'unset');
      /* if (index == 1) {
        $('.calculadora-form-container').css('justify-content', 'flex-start');
      } */
      /* if (index == 1) {
        $(".next").html("Receber Calculo &nbsp<i class='fas fa-arrow-right' style='margin-right: 0px;'></i>");
      } */
      /* if (index == 3) {
        $(".btn-hide").hide();
        $(".previous").hide();
        $(".fim").show();
      } */
    }

    if ($('#pulapasso').val() == 'true') {
      setTimeout(() => {
        navigateTo(curIndex() + 2);
      }, 50);
    }

    function curIndex() {
      // Return the current index by looking at which section has the class 'current'
      return $sections.index($sections.filter(".current"));
    }

    // Previous button is easy, just go back
    $(".btn-container .previous").click(function () {
      navigateTo(curIndex() - 1);
    });

    // Next button goes forward iff current block validates
    $(".btn-container .next").click(function () {
      $("#form-calculadora").parsley().whenValidate({ group: "block-" + curIndex(), }).done(function () {
        navigateTo(curIndex() + 1);
      });
    });

    $("#form-calculadora").submit(function(e){
      e.preventDefault();
      if ($("#form-calculadora").parsley().validate()) {
        var url_geral = $("#infos").data("url-base");
        var dados = $("#form-calculadora").serialize();
        $.ajax({
          type: "POST",
          url: url_geral + "acoes/app/contato/envia_calculadora.php",
          data: dados,
          beforeSend: function () {
            showLoading();
          },
          success: function (data) {
            console.log(data);
            data = $.parseJSON(data);
            console.log(data);
            if (data.status == 'success') {
              // Proxima etapa
              /* setTimeout(() => {
                //navigateTo(curIndex() + 1);
                window.location.href = $("#retorno_success").val() +
                  data.hash;
              }, 3500); */
              hideLoading();
              showAlert(
                "Obrigado!",
                "Enviaremos o resultado do cálculo para o e-mail informado.",
                "success"
              );
              setTimeout(() => {
                location.reload();
              }, 3500);
            } else {
              hideLoading();
              showAlert(
                "Erro",
                "Não foi possível realizar essa operação, revise os dados enviados.",
                "error"
              );
            }
          },
          error: function (xhr, type, exception, data) {
            data = $.parseJSON(data);
            hideLoading();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
            console.log("ajax error response type " + type);
          },
        });
      }
    });

    // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
    $sections.each(function (index, section) {
      $(section)
        .find(":input")
        .attr("data-parsley-group", "block-" + index);
    });
    navigateTo(0); // Start at the beginning

  });

  function flexOf() {
    $("#flexOff").addClass("centerOff");
  }

  function flexOn() {
    $("#flexOff").removeClass("centerOff");
  }

}
/* etapas e processo de calculadora */
